// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticlePreview_container__bX1eg","featuredImagePlaceholder":"ArticlePreview_featuredImagePlaceholder__oQodj","hover":"ArticlePreview_hover__p2O9n"};